import { render, staticRenderFns } from "./portfolio-tab.vue?vue&type=template&id=565b2c2c&scoped=true"
import script from "./portfolio-tab.vue?vue&type=script&lang=js"
export * from "./portfolio-tab.vue?vue&type=script&lang=js"
import style0 from "./portfolio-tab.vue?vue&type=style&index=0&id=565b2c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b2c2c",
  null
  
)

export default component.exports